import EntityAudits from "@/components/EntityAudits.vue";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

const names = {
  sites: "Site.Site",
  list: "Site.Sites",
  new: "Site.SiteNew",
  base: "Site.SiteBase",
  view: "Site.SiteView,",
  notes: "Site.SiteNotes",
  noteEdit: "Site.SiteNoteEdit",
  noteNew: "Site.SiteNoteNew",
  edit: "Site.SiteEdit",
  editStatus: "Site.SiteEditStatus",
  editPriority: "Site.SiteEditPriority",
  documents: "Site.SiteDocuments",
  documentEdit: "Site.SiteDocumentEdit",
  documentNew: "Site.SiteDocumentNew",
  audit: "Site.SiteAudit",
};

export { names as SiteRouteNames };

const SiteRoutes: RouterOptions["routes"] = [
  {
    path: "/sites",
    name: names.sites,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Sites",
        },
        component: () => import("@/views/site/SiteList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/site/SiteBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Site New", isNew: true },
            component: () => import("@/views/site/SiteEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/site/SiteBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Site View" },
            component: () => import("@/views/site/SiteView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Site Edit", isForm: true },
            component: () => import("@/views/site/SiteEdit.vue"),
          },
          {
            path: "editStatus",
            name: names.editStatus,
            meta: { title: "Site Status Edit", isForm: true },
            component: () => import("@/views/site/SiteStatusEdit.vue"),
          },
          {
            path: "editPriority",
            name: names.editPriority,
            meta: { title: "Site Priority Edit", isForm: true },
            component: () => import("@/views/site/SitePriorityEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Site Notes" },
            component: {
              render: () => <EntityNotes idField="siteId" routeNamePrefix="Site.SiteNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Site Note Edit", isForm: true },
            component: () => import("@/views/site/SiteNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Site Note New", isForm: true },
            component: () => import("@/views/site/SiteNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Site Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="site" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Site Document Edit", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="site" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Site Document New", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="site" />,
            },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Site Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Site" />,
            },
          },
        ],
      },
    ],
  },
];
export default SiteRoutes;
